import React, { useEffect }  from "react";
import { useHistory } from "react-router-dom";

import Button from "../../Components/FormElements/Button";

export const Declaration = () => {
  const history = useHistory();

  useEffect(() => {
    window.digitalData.push({
      log: {
        message:
          "La declaración jurada de salud no coincide con la declaración personal de salud",
      },
      event: "trackLog",
    });
  }, []);

  return (
    <div className="wrap">
      <div className="">
        <div className="content-error">
          <div className="content-error__box">
            <div className="content-error__mueble">
              <div className={`content-error__declaration`}></div>
            </div>
          </div>
          <div>
            <div className="content-error__texts">
              <p className="content-error__title">¡Lo sentimos!</p>

              <p className="content-error__subtitle">
                La declaración jurada de salud no coincide con la declaración
                personal de salud (DPS) inicial que realizaste en Simulaciones.
                Puedes volver a simular con los datos del mismo cliente o ir a
                productos.
              </p>
            </div>
            <div className="content-error__actions">
              <Button
                type="button"
                onClick={() => history.push("/simulaciones")}
              >
                Volver a simular
              </Button>
              <Button
                type="button"
                className="is-secondary"
                onClick={() => history.push("/productos")}
              >
                Ir a productos
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
